/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-param-reassign */
import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSessionStorage } from 'usehooks-ts';
import { Button, Modal, Toast, ToastContainer } from 'react-bootstrap';
import useRealTimeNotification from '../hooks/realTimeNotificationService';
import { PriorAuthorizationDomain, PriorAuthorizationDomainDetails, ProcedureDetailDomain } from '../../interfaces/PriorAuthorizationDomain';
import useTimer from '../hooks/useTimer';
import IAuthServicesResponse, { IAuththorizationDetails, IProcedureCodeDetermination } from './IAuthServicesResponse';
import SSORouter from '../SSORouter/SSORouter.Component';
import logo from '../../images/cigna-healthcare-logo.svg';

const PriorAuthRequestSummary: React.FC = () => {
  const eviCoreDelegatedContentRef = useRef(null);
  const location = useLocation();
  const priorAuthorizationDomain = location.state.domainObject as PriorAuthorizationDomain;
  const [anyProcCignaDelegated, setAnyProcCignaDelegatedDelegated] = useState<boolean>(false);
  const [anyProcEvicoreDelegated, setAnyProcEvicoreDelegatedDelegated] = useState<boolean>(false);
  const [receivedAllServiceAuthResponses, setReceivedAllServiceAuthResponses] = useState<boolean>(false);
  const [serviceAuthorizationStatus, _setServiuceAuthorizationStatus] = useState<Array<IAuthServicesResponse>>([]);
  const serviceAuthorizationStatusRef = useRef(serviceAuthorizationStatus);
  const setServiuceAuthorizationStatus = (data: Array<IAuthServicesResponse>): void => {
    serviceAuthorizationStatusRef.current = data;
    _setServiuceAuthorizationStatus(data);
  };

  const [serviceRequestStatusSession, setServiceRequestStatusSessionValue] = useSessionStorage<Record<string, Array<IAuthServicesResponse>>>('serviceRequestStatus', {});

  /* Model variables Start */
  const [requestSuccessSubmittedTimeStr, setRequestSuccessSubmittedDatetime] = useSessionStorage<string>('requestSuccessSubmittedDatetime', (new Date()).toISOString());
  const requestSuccessSubmittedDatetime = new Date(requestSuccessSubmittedTimeStr);

  const { minutes, seconds } = useTimer(requestSuccessSubmittedDatetime.setMinutes(requestSuccessSubmittedDatetime.getMinutes() + 3));

  /* Modal popup */
  const [showSuccessfulMessageAndTimer, setShowSuccessfulMessageAndTimer] = useState<boolean>(true);
  const handleMessageAndTimerPopupClose = () => setShowSuccessfulMessageAndTimer(false);

  /* toast */
  const [showSuccessfulMessageAndTimerToast, setShowSuccessfulMessageAndTimerToast] = useState(false);
  const toggleShowSuccessfulMessageAndTimerToast = () => setShowSuccessfulMessageAndTimerToast(!showSuccessfulMessageAndTimerToast);
  /* Model variables End */

  const {
    addUserToGroup,
    removeUserFromGroup,
    onMessageReceive,
    stopConnection,
    isConnected,
  } = useRealTimeNotification();

  const handleAuthResponse = (serviceRequestStatus : IAuthServicesResponse) => {
    // Request From Shri to handle No auth with 'See Message'
    _.each(serviceRequestStatus.authorizations, (auth: IAuththorizationDetails) => {
      if (auth.status && auth.status.toLowerCase() === 'noauth') {
        auth.status = 'See Message';
      }
    });

    const serviceAuthorizationStatusTemp = [...serviceAuthorizationStatusRef.current];
    const matchingAuth = _.find(serviceAuthorizationStatusTemp, { serviceRequestId: serviceRequestStatus.serviceRequestId });
    if (matchingAuth) {
      matchingAuth.error = serviceRequestStatus.error;
      if (matchingAuth.error) {
        _.each(matchingAuth.authorizations, function (auth: IAuththorizationDetails) {
          auth.message = matchingAuth?.error?.message ?? '';
          auth.status = 'N/A';
          auth.id = 'N/A';
          auth.noOfDaysApproved = 'N/A';
          _.each(auth.proceduresDetails, function (procedureCode: IProcedureCodeDetermination) {
            procedureCode.message = '';
          });
        });
      } else {
        matchingAuth.authorizations = serviceRequestStatus.authorizations ?? [];
      }
      setServiuceAuthorizationStatus(serviceAuthorizationStatusTemp);
    }
  };

  useEffect(() => {
    const groupName = priorAuthorizationDomain.groupingKey.toLowerCase();
    if (isConnected) {
      addUserToGroup(groupName);
      onMessageReceive('TCResponse', handleAuthResponse);
    }

    return () => {
      if (isConnected) {
        removeUserFromGroup(groupName);
      }
    };
  }, [isConnected]);

  useEffect(() => {
    const authorizationDomainDetailsTemp = _.cloneDeep(priorAuthorizationDomain?.priorAuthorizationDomianDetails);
    const allProcedureCodesTemp: Array<ProcedureDetailDomain> = _.flatten(_.map(authorizationDomainDetailsTemp, 'proceduresDetails'));
    const _anyProcCignaDelegated = _.some(allProcedureCodesTemp, { processedBy: 'C' });
    setAnyProcCignaDelegatedDelegated(_anyProcCignaDelegated);
    setAnyProcEvicoreDelegatedDelegated(_.some(allProcedureCodesTemp, { processedBy: 'E' }));

    const serviceStatus: Array<IAuthServicesResponse> = [];

    if (authorizationDomainDetailsTemp && _anyProcCignaDelegated === true) {
      _.each(authorizationDomainDetailsTemp, function (service: PriorAuthorizationDomainDetails) {
        const cignaDelegatedProcedureCode = _.filter(service.proceduresDetails, { processedBy: 'C' }).map((item: ProcedureDetailDomain) => {
          return {
            procedureCode: item.procedureCode,
            units: item.unitFrequency,
            unitType: item.unitType,
            message: 'Awaiting response...',
          } as IProcedureCodeDetermination;
        });

        if (cignaDelegatedProcedureCode.length > 0) {
          serviceStatus.push({
            typeOfService: service.typeOfServiceDescription,
            serviceRequestId: service.serviceRequestId,
            authorizationType: service.authorizationType,
            authorizations: [
              {
                id: 'Awaiting response...',
                message: 'Awaiting response...',
                noOfDaysApproved: 'Awaiting response...',
                status: 'Awaiting response...',
                proceduresDetails: cignaDelegatedProcedureCode,
              },
            ],
          });
        }
      });
      setServiuceAuthorizationStatus(serviceStatus);

      if (serviceRequestStatusSession[priorAuthorizationDomain.groupingKey]) {
        _.each(serviceRequestStatusSession[priorAuthorizationDomain.groupingKey], function (authResponseSessionState: IAuthServicesResponse) {
          if (authResponseSessionState.authorizations && authResponseSessionState.authorizations[0].status !== 'Awaiting response...') {
            handleAuthResponse(authResponseSessionState);
          }
        });
      }
    }
    setRequestSuccessSubmittedDatetime((new Date()).toISOString());
  }, [priorAuthorizationDomain?.priorAuthorizationDomianDetails]);

  const checkIfAllServiceAuthResponsesReceived = () => {
    const serviceAuthorizationStatusTemp = [...serviceAuthorizationStatusRef.current];
    const check = _.every(serviceAuthorizationStatusTemp, function (item) { return item.authorizations && item.authorizations[0].id !== 'Awaiting response...'; });
    setReceivedAllServiceAuthResponses(check);
  };

  const saveTruecareResponseToSession = () => {
    const serviceRequestStatusSessionTemp = { ...serviceRequestStatusSession };
    serviceRequestStatusSessionTemp[priorAuthorizationDomain.groupingKey] = serviceAuthorizationStatusRef.current;
    setServiceRequestStatusSessionValue(serviceRequestStatusSessionTemp);
  };

  useEffect(() => {
    saveTruecareResponseToSession();
    checkIfAllServiceAuthResponsesReceived();
  }, [serviceAuthorizationStatusRef.current]);

  useEffect(() => {
    if (receivedAllServiceAuthResponses) {
      handleMessageAndTimerPopupClose();
      setShowSuccessfulMessageAndTimerToast(false);
      stopConnection();
    }
  }, [receivedAllServiceAuthResponses]);

  const getTotalResponsesReceived = useCallback(() => {
    const serviceAuthorizationStatusTemp = [...serviceAuthorizationStatusRef.current];
    const totalResponseReceived = _.filter(serviceAuthorizationStatusTemp, function (item) { return item.authorizations && item.authorizations[0].id !== 'Awaiting response...'; }).length;
    return (
      <div>
        Response received: <span className="fw-bold font-weight-bold"> {totalResponseReceived} / {serviceAuthorizationStatusTemp.length}</span>
      </div>
    );
  }, [serviceAuthorizationStatusRef]);

  const getTimerContent = useCallback(() => {
    return (
      <div>
        {getTotalResponsesReceived()}
        {
                    (minutes > 0 || seconds > 0)
                    && <div>Time left: <span className="fw-bold font-weight-bold">{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</span> </div>
                }
        {
                    minutes <= 0 && seconds <= 0
                    && <div>Time exceeded, please follow up on your Cigna for Health Care Professionals dashboard after 3 hours</div>
                }
      </div>
    );
  }, [minutes, seconds]);

  const handleDone = () => {
    window.opener = null;
    window.open('', '_self');
    window.close();
  };

  return (
    <div>
      <header className="App-header" data-testid="header">
        <div className="header-alignment">
          <img title="Health-Plan-Logo" src={logo} />
        </div>
      </header>
      {
                anyProcCignaDelegated
                && <main className="content-wrapper">
                  <ToastContainer className="toast-container pe-3 position-fixed top-0 end-0 pt-1">
                    <Toast show={showSuccessfulMessageAndTimerToast}>
                      <Toast.Header closeButton={false}>
                        <strong className="me-auto">Timer</strong>
                      </Toast.Header>
                      <Toast.Body>
                        <div data-testid="toast-timer-content">
                          {getTimerContent()}
                        </div>
                      </Toast.Body>
                    </Toast>
                  </ToastContainer>
                  <Modal
                    show={showSuccessfulMessageAndTimer}
                    onHide={handleMessageAndTimerPopupClose}
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton={false}>
                      <Modal.Title>Submission Successful</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div data-testid="modal-message">
                        Your <span className="fw-bold font-weight-bold">Precertification Request</span> has been submitted.
                        One moment while we process your request. Please remain on this page as our response may take up to <span className="fw-bold font-weight-bold">3 minutes</span>.
                      </div>
                      <div data-testid="model-timer-content">
                        {getTimerContent()}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        onClick={() => {
                          handleMessageAndTimerPopupClose();
                          toggleShowSuccessfulMessageAndTimerToast();
                        }}
                        data-testid="modal-close-btn"
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <div className="container pt-4 col-auto" id="precert-summary-page" data-testid="precert-summary-page">
                    <h2 className="text-content-default mt-2">Precertification Results</h2>
                    <section id="summary-results-cigna" data-testid="summary-results-cigna">
                      <div className="card mt-4">
                        <div className="card-body ">
                          <div className="row ">
                            <div className="col-12">
                              <h4 className="mb-3">Cigna Precertification Submission Results</h4>
                              <span>
                                Please note that all information will not be visible on the dashboard until a later time.
                                {
                                                    anyProcEvicoreDelegated
                                                    && <button
                                                      className="btn btn-link text-sm"
                                                      onClick={() => {
                                                        if (eviCoreDelegatedContentRef.current) {
                                                          (eviCoreDelegatedContentRef.current as any).scrollIntoView({
                                                            behaviour: 'smooth',
                                                            block: 'start',
                                                          });
                                                        }
                                                      }}
                                                    >See next steps.
                                                    </button>
                                                }
                              </span>
                              <div className="card my-2">
                                <ul className="list-group list-group-flush">
                                  {
                                                    serviceAuthorizationStatusRef.current
                                                    && serviceAuthorizationStatusRef.current.map(
                                                      (service: IAuthServicesResponse) => {
                                                        return (
                                                          <li data-testid="service-item" className="list-group-item" key={`${service.serviceRequestId}`}>
                                                            <div className="form-group service-1 mb-0">
                                                              <h5>
                                                                <strong data-testid="service-auth-type">{service.authorizationType} - {service.typeOfService}</strong>
                                                                {
                                                                                service.authorizations && service.authorizations[0].id !== 'Awaiting response...'
                                                                                && <i className="align-items-end col fa-check-circle fa-fw fa-md fas text-success ms-2" />
                                                                            }
                                                                {
                                                                                service.authorizations && service.authorizations[0].id === 'Awaiting response...'
                                                                                && <div className="spinner-border spinner-border-sm text-success mb-1 ms-3" role="status">
                                                                                  <span className="sr-only">Loading...</span>
                                                                                </div>
                                                                            }
                                                              </h5>
                                                              {
                                                                            service.authorizations
                                                                            && service.authorizations.map((auth: IAuththorizationDetails, index: number) => {
                                                                              return (
                                                                                <div key={auth.id} data-testid="service-auth">
                                                                                  {
                                                                                            index > 0 && <hr className="mt-0" />
                                                                                        }
                                                                                  <div className="form-group mb-0">
                                                                                    <div className="row">
                                                                                      <div className="col-12">
                                                                                        <label className="fw-bold font-weight-bold mb-0" data-testid="auth-id-label">Authorization ID for Procedures: ({auth.id}) <span className="fw-light font-weight-light">({auth.proceduresDetails.length} Total)</span></label>
                                                                                      </div>
                                                                                    </div>
                                                                                    {
                                                                                                (auth.noOfDaysApproved || auth.status)
                                                                                                && <div className="row">
                                                                                                  <div className="col-12">
                                                                                                    {
                                                                                                            auth.noOfDaysApproved
                                                                                                            && <label className="fw-bold font-weight-bold mb-0" data-testid="auth-numberofdays-label">Number of Days: <span className="fw-light font-weight-light">{auth.noOfDaysApproved}</span> | </label>
                                                                                                        }
                                                                                                    {
                                                                                                            auth.status
                                                                                                            && <label className="ms-3 fw-bold font-weight-bold mb-0" data-testid="auth-status-label">Status: <span className="fw-light font-weight-light">{auth.status}</span></label>
                                                                                                        }
                                                                                                  </div>
                                                                                                </div>
                                                                                            }
                                                                                    {
                                                                                                auth.message
                                                                                                && <div className="row">
                                                                                                  <div className="col-12">
                                                                                                    <label className="fw-bold font-weight-bold mb-0" data-testid="auth-message-label">Authorization Message: <span className="fw-light font-weight-light">{auth.message}</span></label>
                                                                                                  </div>
                                                                                                </div>
                                                                                            }
                                                                                    <div className="tab-content mt-1">
                                                                                      {
                                                                                                                auth.proceduresDetails.map((procedureCode: IProcedureCodeDetermination) => {
                                                                                                                  return (
                                                                                                                    <div className={procedureCode.procedureCode !== '' ? 'tab-pane fade show active' : 'tab-pane fade show active disabled'} key="ProcedureDiv">
                                                                                                                      <div className="table-full-width table-responsive">

                                                                                                                        <table className={procedureCode.procedureCode !== '' ? 'table font-size-sm rounded sortable-table table-bordered table-hover table-striped' : 'table font-size-sm  rounded sortable-table table-bordered table-hover table-striped disabled'} key="Procedures" summary="Procedures">
                                                                                                                          <thead>
                                                                                                                            <tr>
                                                                                                                              <th scope="col" className="align-top w-20">Procedure Code </th>
                                                                                                                              <th scope="col" className="align-top w-20">Number of Units </th>
                                                                                                                              <th scope="col" className="align-top">Message</th>
                                                                                                                            </tr>
                                                                                                                          </thead>
                                                                                                                          <tbody>

                                                                                                                            <tr data-testid="procedure-item" key={procedureCode.procedureCode}>
                                                                                                                              <td data-testid="code">{procedureCode.procedureCode}</td>
                                                                                                                              <td data-testid="units-n-type">{procedureCode.units !== '' && procedureCode.units !== undefined && procedureCode.units !== null ? procedureCode.units : ''} {procedureCode.unitType ? `(${procedureCode.unitType})` : ''}</td>
                                                                                                                              <td data-testid="message">{procedureCode.procedureCode !== '' ? procedureCode.message : ''}</td>
                                                                                                                            </tr>

                                                                                                                          </tbody>
                                                                                                                        </table>

                                                                                                                      </div>
                                                                                                                    </div>
                                                                                                                  );
                                                                                                                })
                                                                                                            }
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              );
                                                                            })
                                                                        }
                                                            </div>
                                                          </li>
                                                        );
                                                      },
                                                    )
                                                    }
                                </ul>
                              </div>
                              {
                                                !anyProcEvicoreDelegated
                                                && <div className="mt-5 col-12 d-none d-lg-inline-flex justify-content-start p-0">
                                                  <div className="col d-inline-flex justify-content-end pr-0 pl-0">
                                                    <button className="btn btn-primary rounded-pill px-4" data-testid="summary-done-btn" onClick={handleDone}>Done</button>
                                                  </div>
                                                </div>
                                            }
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    {
                            anyProcEvicoreDelegated
                            && <section id="summary-results-evicore" ref={eviCoreDelegatedContentRef} data-testid="summary-results-evicore">
                              <h2 className="text-content-default mt-4">Precertification Next Steps</h2>
                              <div className="card mt-4">
                                <div className="card-body">
                                  <SSORouter priorAuthDomainObj={priorAuthorizationDomain} isSummaryPage={true} isDisabledCompleteRequestButton={(!receivedAllServiceAuthResponses && !(minutes <= 0 && seconds <= 0))} />
                                </div>
                              </div>
                            </section>
                        }
                  </div>
                </main>
            }
    </div>
  );
};

export default PriorAuthRequestSummary;
